import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import axios from 'axios'
import config from 'config'
import { addDays } from 'date-fns'

import useSnackbar from '../Snackbar/useSnackbar'

const useAssignmentSession = () => {
  const { t } = useTranslation()
  const { showSnackbarMessage } = useSnackbar()

  const [state, setState] = useState({
    isFetching: false,
    isUpdating: false,
    error: null,
  })

  const setStartUpdating = useCallback(() => {
    setState((s) => ({
      ...s,
      isFetching: false,
      isUpdating: true,
    }))
  }, [setState])

  const setStopUpdating = useCallback(() => {
    setState((s) => ({
      ...s,
      isUpdating: false,
    }))
  }, [setState])

  const setSuccessFetching = useCallback(
    (data) => {
      setState((s) => ({
        ...s,
        isFetching: false,
        isUpdating: false,
        ...data,
        error: null,
      }))
    },
    [setState]
  )

  const startAssignment = useCallback(
    async (sessionId) => {
      setStartUpdating()

      try {
        const result = await axios.post(
          `${config.apiBaseUrl}sessions/${sessionId}/assignment/start`
        )

        setSuccessFetching(result.data.body)
      } catch (e) {
        const message =
          e.response?.data?.message ||
          t('common.error.fetchData', {
            attribute: e.response?.status,
          })

        setStopUpdating()

        showSnackbarMessage({
          severity: 'error',
          message,
        })
      }
    },
    [
      setStartUpdating,
      setStopUpdating,
      setSuccessFetching,
      showSnackbarMessage,
      t,
    ]
  )

  const confirmAssignment = useCallback(
    async (sessionId) => {
      setStartUpdating()

      try {
        const result = await axios.post(
          `${config.apiBaseUrl}sessions/${sessionId}/confirm-assignment`,
          { availabilityAt: addDays(new Date(), 1) }
        )

        setSuccessFetching(result.data.body)
      } catch (e) {
        const message =
          e.response?.data?.message ||
          t('common.error.fetchData', {
            attribute: e.response?.status,
          })

        setStopUpdating()

        showSnackbarMessage({
          severity: 'error',
          message,
        })
      }
    },
    [
      setStartUpdating,
      setStopUpdating,
      setSuccessFetching,
      showSnackbarMessage,
      t,
    ]
  )

  return {
    // isFetching: state.isFetching,
    isUpdating: state.isUpdating,
    error: state.error,
    result: state.result,
    assignmentEndedAt: state.assignmentEndedAt,
    startAssignment,
    confirmAssignment,
  }
}

export default useAssignmentSession
